import { Stack } from '@atlaskit/primitives';
import Link from '@atlaskit/link';
import { defineMessages, FormattedMessage } from 'react-intl';

import { useSwitchAccountLink, useUser } from '#definitions/user';

const messages = defineMessages({
  title: {
    id: 'trello.login.title',
    defaultMessage: 'You are logged in as:',
    description: 'Heading for where you are logged in as',
  },
  name: {
    id: 'trello.login.name',
    defaultMessage: 'Name',
    description: 'Heading for full name',
  },
  username: {
    id: 'trello.login.username',
    defaultMessage: 'Username',
    description: 'Heading for username',
  },
});

const LoginDetails = () => {
  const user = useUser();
  const switchAccountLink = useSwitchAccountLink();
  return (
    <Stack alignInline="center" space="space.200">
      <FormattedMessage {...messages.title} />
      <Stack alignInline="center">
        <FormattedMessage {...messages.name} />
        <strong>{user?.name}</strong>
      </Stack>
      <Stack alignInline="center">
        <FormattedMessage {...messages.username} />
        <strong>{user?.email}</strong>
      </Stack>
      <Link href={switchAccountLink}>Switch Account</Link>
    </Stack>
  );
};

export default LoginDetails;
